import React from 'react';
import { Divider } from 'semantic-ui-react'

const ConfSerO1 = ({styles, handleClickRegr}) => {
  return (
    <div>
      <button className="ui right labeled icon button fluid" type='submit' style={styles.titBuscar}>
        <i className="large settings yellow icon"></i>
        Configurar
      </button>

      <Divider inverted />

      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickRegr}>
        <i className="large arrow left violet icon"></i>
        Regresar
      </button>
    </div>
  )
};

export default ConfSerO1
